import React from "react";
import { Link } from "react-router-dom";

const NAV_LINKS = [
  { to: "/#home", label: "Home" },
  { to: "/#about", label: "About" },
  { to: "/#practice", label: "Practice Areas" },
  { to: "/#attorneys", label: "Attorneys" },
  { to: "/#contact", label: "Contact" },
];

function Column({ title, children, testId }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-widest text-[#d4b87a] mb-4">{title}</div>
      <ul className="space-y-2 text-sm" data-testid={testId}>{children}</ul>
    </div>
  );
}

export function FooterBrand({ firm }) {
  return (
    <div className="md:col-span-2">
      <div className="mb-5">
        <img src="/assets/hbhs-logo-clean-gold.png" alt="Hilty, Bower, Haws & Seable, PLLC" className="h-16 md:h-20 w-auto" />
      </div>
      <p className="text-stone-400 text-sm max-w-md leading-relaxed">
        Idaho&rsquo;s trusted counsel for more than four decades &mdash; grounded in professionalism, integrity, and personal service.
      </p>
      <div className="mt-6 grid sm:grid-cols-2 gap-4 max-w-lg">
        {firm.offices.map((o) => (
          <div key={o.label} className="text-sm">
            <div className="text-[11px] uppercase tracking-[0.2em] text-[#d4b87a] mb-1">{o.label}</div>
            <div className="text-stone-400">{o.street}</div>
            <div className="text-stone-400">{o.city}, {o.state} {o.zip}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function FooterNav() {
  return (
    <Column title="Navigate">
      {NAV_LINKS.map((l) => (
        <li key={l.to}><Link to={l.to} className="hover:text-white">{l.label}</Link></li>
      ))}
    </Column>
  );
}

export function FooterPracticeLinks({ practiceAreas }) {
  return (
    <Column title="Practice Areas" testId="footer-practice-links">
      {practiceAreas.map((a) => (
        <li key={a.id}><Link to={`/practice-areas/${a.id}`} className="hover:text-white">{a.title}</Link></li>
      ))}
    </Column>
  );
}

export function FooterContact({ firm }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-widest text-[#d4b87a] mb-4">Contact</div>
      <ul className="space-y-2 text-sm text-stone-400">
        {firm.phones.map((p) => (
          <li key={p}><a href={`tel:${p.replace(/\D/g, "")}`} className="hover:text-white">{p}</a></li>
        ))}
        <li><a href={`mailto:${firm.email}`} className="hover:text-white">{firm.email}</a></li>
        <li className="pt-2 text-stone-500">{firm.hours}</li>
      </ul>
    </div>
  );
}
